// extracted by mini-css-extract-plugin
export default {"fileDropZone":"ProductImagesModal_fileDropZone__se8qX","descr":"ProductImagesModal_descr__IhHVf","dragOver":"ProductImagesModal_dragOver__dPQ+o"};